export default __webpack_public_path__ + "static/media/edit-2.32824fbb.svg";